import { useCallback } from "react";

//handle wheel scroll number input
export function usePreventWheelChange() {
  return useCallback((e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  }, []);
}
